import {Link} from "react-router-dom";

import AuthenticationLayout from "../layouts/AuthenticationLayout";
import useTranslation from "../hooks/translations";
import {Button, Form} from "react-bootstrap";
import {useMemo, useRef, useState} from "react";
import InputField from "../components/InputField";
import {useApi} from "../contexts/ApiProvider";
import UserService from "../services/UserService";
import {toast} from "react-toastify";

export default function ForgotPasswordPage() {
  const translations = useTranslation();
  const api = useApi()
  const userService = useMemo(() => new UserService(api), [api]);

  const emailField = useRef();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (event) => {
    event.preventDefault();
    const email = emailField.current.value;

    const errors = {};
    if (!email) {
      errors.email = translations.errorEmail;
    }

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }

    const response = await userService.forgotPassword({
      email: email,
    })
    if (response.ok) {
      emailField.current.value = "";
      toast.info(translations.forgotPasswordEmailSent);
    }
  };

  return (
    <AuthenticationLayout>
      <div className="col-lg-5">
        <div className="card shadow-lg border-0 rounded-lg mt-5">
          <div className="card-header justify-content-center">
            <h3 className="fw-light my-4">{translations.passwordForgotten}</h3>
          </div>
          <div className="card-body">
            <div
              className="small mb-3 text-muted">{translations.forgotPasswordDescription}
            </div>
            <Form onSubmit={onSubmit}>
              <div className="mb-3">
                <InputField
                  name="inputEmailAddress"
                  label={translations.email}
                  placeholder={translations.enterEmail}
                  error={formErrors.email}
                  fieldRef={emailField}
                  maxLength={120}
                />
              </div>
              <div
                className="d-flex align-items-center justify-content-between mt-4 mb-0">
                <Link className="small"
                      to="/login">{translations.returnToLogin}</Link>
                <Button className="btn btn-primary"
                        type="submit">{translations.forgotPasswordRequest}</Button>
              </div>
            </Form>
          </div>
          {/*<div className="card-footer text-center">*/}
          {/*  <div className="small">*/}
          {/*    <Link to="/register">Need an account? Sign up!</Link>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </div>
    </AuthenticationLayout>
  );
}
